import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ReactTooltip from 'react-tooltip';

import FormattedCurrency from 'components/ui/FormattedCurrency';
import { MEDIA_QUERIES } from 'constants/breakpoints';
import { upgradePriceBreakdownShape } from 'constants/propTypes';
import { useMediaQuery } from 'hooks/useMediaQuery';
import getPassengerTypeTranslationId from 'utils/getPassengerTypeTranslationId';

import { StyledUpgradePriceBreakdownTotal } from './ClickableCell.styles';

const UpgradePriceTooltip = ({ id, currency, breakdown: { items, total } }) => {
  const hasMouse = useMediaQuery(MEDIA_QUERIES.hasMouse);
  const touchEvents = hasMouse ? {} : { event: 'click', globalEventOff: 'touchstart' };
  const formatPrice = (amount) => <FormattedCurrency currency={currency} amount={amount} hideEmptyDecimals={Number.isInteger(amount)} />;

  return (
    <ReactTooltip id={id} effect="solid" place="top" data-cy="upgrade-price-tooltip" {...touchEvents}>
      {items.map(({ passengerType, quantity, difference, total: itemTotal }) => (
        <div key={`${passengerType}-${difference}`} data-testid="upgrade-price-breakdown-item">
          {quantity} <FormattedMessage id={getPassengerTypeTranslationId(passengerType, quantity)} /> x {formatPrice(difference)} ={' '}
          {formatPrice(itemTotal)}
        </div>
      ))}
      <StyledUpgradePriceBreakdownTotal data-testid="upgrade-price-breakdown-total">
        <FormattedMessage id="summary.total" /> = {formatPrice(total)}
      </StyledUpgradePriceBreakdownTotal>
    </ReactTooltip>
  );
};

UpgradePriceTooltip.propTypes = {
  id: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  breakdown: upgradePriceBreakdownShape.isRequired
};

export default UpgradePriceTooltip;
